export function setBackgroundElement() {
	$("[setBackground]").each(function () {
		var background = $(this).attr("setBackground");
		$(this).css({
			"background-image": "url(" + background + ")",
			"background-size": "cover",
			"background-position": "center center",
		});
	});
	$("[setBackground]").each(function () {
		var background = $(this).attr("setBackground");
		$(this).css({
			"background-image": "url(" + background + ")",
			"background-size": "cover",
			"background-position": "center center",
		});
	});
}
export function detectCloseElement(ele, ele2, funcRemove) {
	// close
	$(document).on("click", function (e) {
		console.log();
		if (!$(e.target).closest(ele).length && !$(e.target).hasClass(ele2)) {
			funcRemove();
		}
	});
	// esc
	$(document).keyup(function (e) {
		if (e.key === "Escape") {
			funcRemove();
		}
	});
	// overlay-blur
	// close
	$(document).on("click", function (e) {
		console.log();
		if (!$(e.target).closest(ele).length && !$(e.target).hasClass(ele2)) {
			funcRemove();
		}
	});
	// esc
	$(document).keyup(function (e) {
		if (e.key === "Escape") {
			funcRemove();
		}
	});
	// overlay-blur
}
export function buttonToTop() {
	let windowHeight = $(window).height();
	$(document).on("scroll", function () {
		let scrollTop = $(window).scrollTop();
		let documentHeight = $(document).height();
		if (scrollTop + windowHeight > documentHeight - windowHeight) {
			$(".button-to-top").addClass("active");
		} else {
			$(".button-to-top").removeClass("active");
		}
	});
	$(document).on("click", ".button-to-top", function () {
		$("html, body").animate({ scrollTop: 0 });
	});
}

export function ToggleItem() {
	const nodeParent = $(".wrap-item-toggle");
	const nodeItem = nodeParent.find(".item-toggle");
	const nodeTitle = nodeItem.find(".title");
	nodeTitle.on("click", function () {
		$(this)
			.toggleClass("active")
			.next()
			.slideToggle()
			.closest(".item-toggle")
			.siblings()
			.find(".title")
			.removeClass("active")
			.next()
			.slideUp();
	});
}

/**
 * parent, children, item, button, initItem
 * @param { parent, children, item, button, initItem} listNode
 */
export function funcExpandContent(listNode) {
	const { parent, children, item, button, initItem, gap = 0 } = listNode;
	if (!$(parent).length) return;
	let itemHeight = $(item).outerHeight();
	let gapCalculate = gap
		? Number($(parent).find(children).css("column-gap").slice(0, -2)) * gap
		: 0;
	let initHeight = itemHeight * initItem + gapCalculate;
	let originalHeight = $(parent).find(children).outerHeight();
	if (originalHeight < initHeight) {
		$(button).remove();
	} else {
		$(parent).css("height", initHeight);
	}
	$(button).on("click", function () {
		if ($(this).hasClass("expand")) {
			$(parent).css("height", initHeight);
			$(this).find("span").text("Xem thêm");
		} else {
			$(parent).css("height", originalHeight);
			// setTimeout(() => {
			// 	$(parent).css("height", "auto");
			// }, 1000);
			$(this).find("span").text("Rút gọn");
		}
		$(this).toggleClass("expand");
	});
}

export function clickScrollToDiv(nodeEle, heightSpacing = () => {}) {
	$(nodeEle).on("click", function (event) {
		let height = 0;
		$(this).addClass("active").siblings().removeClass("active");
		if (heightSpacing) {
			height = heightSpacing();
		} else {
			height = 0;
		}
		if (this.hash !== "") {
			event.preventDefault();
			var hash = this.hash;
			$("html, body").animate(
				{
					scrollTop: $(hash).offset().top - height,
				},
				800
			);
		}
	});
}

export function appendCaptchaASP() {
	if (!$("#ctl00_mainContent_ctl01_pnlFormWizard").length) return;
	// Select the div element you want to observe
	const myDiv = document.querySelector(
		"#ctl00_mainContent_ctl01_pnlFormWizard"
	);
	// Create a new MutationObserver object
	const observer = new MutationObserver(function (mutations) {
		mutations.forEach(function (mutation) {
			console.log("Run");
			appendCaptcha();
		});
	});
	// Configure the observer to listen for changes to the "class" attribute
	const config = { attributes: true, characterData: true, childList: true };
	// Start observing the target div element
	observer.observe(myDiv, config);
	function appendCaptcha() {
		$(".form-group.frm-captcha").appendTo(".wrap-form-submit");
		$(".form-group.frm-btnwrap").appendTo(".wrap-form-submit");
	}
	appendCaptcha();
}

// location-section.js
export function initLocationSection() {
	$(document).ready(function () {
		// Get all location items
		const $locationItems = $(".location-item");

		// Set default active location
		$locationItems
			.filter('[data-location="ho-chi-minh"]')
			.addClass("active");

		// Add click event listener to each item
		$locationItems.on("mouseenter", function () {
			// Remove active class from all items
			$locationItems.removeClass("active");

			// Add active class to clicked item
			$(this).addClass("active");
		});
	});
}

// export function viewMoreAbout() {
//   // $(document).ready(function () {
//   //   // Show view-more button by default
//   //   $(".view-more").show();
//   //   $(".view-less").hide();
//   //   $(".view-more").on("click", function () {
//   //     $(".content-about").toggleClass("active");
//   //     $(".view-more").hide();
//   //     $(".view-less").show();
//   //   });
//   //   $(".view-less").on("click", function () {
//   //     $(".content-about").toggleClass("active");
//   //     $(".view-more").show();
//   //     $(".view-less").hide();
//   //   });
//   // });
// }
//export function viewMoreAbout() {
//	$(document).ready(function () {
//		// Get initial height of first paragraph
//		const initialHeight = $(".content-about").height();
//		$(".content-about").css("height", initialHeight);

//		// Show view-more button by default
//		$(".view-more").show();
//		$(".view-less").hide();

//		$(".view-more").on("click", function () {
//			$(".content-about").css("height", "auto");
//			$(".content-about").toggleClass("active");
//			$(".view-more").hide();
//			$(".view-less").show();
//		});

//		$(".view-less").on("click", function () {
//			$(".content-about").css("height", initialHeight);
//			$(".content-about").toggleClass("active");
//			$(".view-more").show();
//			$(".view-less").hide();
//		});

//		// Check if content is taller than first paragraph
//		const contentHeight = $(".content-about").prop("scrollHeight");
//		if (contentHeight <= initialHeight) {
//			$(".view-more").hide();
//		} else {
//			$(".view-more").show();
//		}
//	});
//}

export function initTabTeam() {
	$(document).ready(function () {
		// Show the first tab by default
		$(".tabs-stage > div:not(:first)").hide();
		$(".tabs-nav li:first").addClass("tab-active");

		// Change tab class and display content
		$(".tabs-nav a").on("click", function (event) {
			event.preventDefault();
			const targetTab = $(this).attr("href");

			// Update active tab styling
			$(".tabs-nav li").removeClass("tab-active");
			$(this).parent().addClass("tab-active");

			// Show/hide tab content with fade effect
			$(".tabs-stage > div").fadeOut(200);
			setTimeout(() => {
				$(targetTab).fadeIn(200);
			}, 200);
		});
	});
}
